import useFreeShipping from '@package/hooks/src/useFreeShipping';

import styles from './ToFreeShippingsContent.module.css';

export default function ToFreeShippingsContent({ freeShippingsContent }: any) {
  let freeShippingMessage = freeShippingsContent;

  if (!freeShippingMessage) {
    const { freeShippingHtml } = useFreeShipping();
    freeShippingMessage = freeShippingHtml;
  }

  return (
    <div className={styles.wrapper}>
      {freeShippingMessage ? (
        <div dangerouslySetInnerHTML={{ __html: freeShippingMessage }} />
      ) : (
        <div className="flex w-full min-h-[150px] items-center justify-center">
          <div className="relative -top-8 -left-8">
            <div className="w-16 h-16 rounded-full absolute border border-solid border-secondary-first"></div>
            <div className="w-16 h-16 rounded-full animate-spin absolute border border-solid border-yellow-rating border-t-transparent"></div>
          </div>
        </div>
      )}
    </div>
  );
}
